export const isPrivateLabel = (label: string) => label.startsWith('__');
